export default __webpack_public_path__ + "static/footer-blob-73f256655da8eaad0df3021deca7d1b0.png";